import CreateUserPanel from '@frontend/components/user-access/CreateUserPanel';

export interface RealmIdentityPanelProps {
  expanded: boolean;
  onToggle: () => void;
}

/** Realm-scoped create/invite with optional ecosystem attach on create. */
export default function RealmIdentityPanel({ expanded, onToggle }: RealmIdentityPanelProps) {
  return (
    <CreateUserPanel
      expanded={expanded}
      onToggle={onToggle}
      ecosystemAttachMode="optional"
    />
  );
}
